import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressSortPipe } from './pipe/address-sort.pipe';
import { LocalizedDatePipe } from './pipe/localized-data.pipe';
import { DataDirective } from './directives/data.directive';
import { TimeDirective } from './directives/time.directive';
import { PhoneDirective } from './directives/phone.directive';

import { MapComponent } from './components/map/map.component';
import { AssignCarComponent } from './components/assign-car/assign-car.component';
import { MaterialModule } from '../material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DistancePipe } from './pipe/distance.pipe';
import { SecurePhoneDirective } from './directives/secure-phone.directive';
import { LocTimePipe } from './pipe/loc-time.pipe';
import { BlockReasonComponent } from './components/block-reason/block-reason.component';
import { CurrencyFareSelectComponent } from './components/currency-select/currency-select.component';
import { BlockComponent } from './components/block/block.component';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { CustomTranslationFieldComponent } from './components/custom-translation-field/custom-translation-field.component';
import { CustomTranslatePipe } from './pipe/custom-translate.pipe';

@NgModule({
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, TranslateModule],
  declarations: [
    DistancePipe,
    AddressSortPipe,
    LocalizedDatePipe,
    DataDirective,
    TimeDirective,
    PhoneDirective,
    MapComponent,
    AssignCarComponent,
    SecurePhoneDirective,
    LocTimePipe,
    BlockReasonComponent,
    CurrencyFareSelectComponent,
    BlockComponent,
    NumbersOnlyDirective,
    CustomTranslationFieldComponent,
    CustomTranslatePipe
  ],
  exports: [
    DistancePipe,
    AddressSortPipe,
    LocalizedDatePipe,
    DataDirective,
    TimeDirective,
    PhoneDirective,
    MapComponent,
    AssignCarComponent,
    SecurePhoneDirective,
    BlockReasonComponent,
    BlockComponent,
    CurrencyFareSelectComponent,
    LocTimePipe,
    NumbersOnlyDirective,
    CustomTranslationFieldComponent,
    CustomTranslatePipe
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts